<cui-claim-header-search
  (claimSearched)="searchClaim($event)"
  data-pgr-id="claimHeaderSearch"
></cui-claim-header-search>
@if (isLoading) {
<cui-spinner ariaLabel="Loading Claim"></cui-spinner>
}
